<span [ngSwitch]="icon" style="float: none;display: initial;">
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bac_intervention'" viewBox="0 0 101.37 95.95">
    <defs>
      <style>
        .cls-1 {
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 0.95px;
        }
      </style>
    </defs>
    <title>-Fichier 1unic-fond</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M.7,9.18,7.39,20.26a1.61,1.61,0,0,0,1,.75l6.25,1.48L36.09,42.74l2.37-2.23L16.71,19.93a1.73,1.73,0,0,0-.78-.41l-6-1.43L4.23,8.66,9.12,4l10,5.4,1.51,5.67a1.49,1.49,0,0,0,.44.74L42.79,36.41l2.37-2.23L23.75,13.92,22.18,8a1.56,1.56,0,0,0-.79-1L9.68.7a1.74,1.74,0,0,0-2,.25L1,7.28A1.51,1.51,0,0,0,.7,9.18Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M80.78,38.46c11,0,20-8.41,20.07-18.86a17.53,17.53,0,0,0-.62-4.72,1.72,1.72,0,0,0-2.8-.74L87,24l-8.27-2.61L76,13.57,86.41,3.71a1.52,1.52,0,0,0,0-2.23,1.65,1.65,0,0,0-.78-.42C74.91-1.51,64,4.63,61.31,14.76a18.28,18.28,0,0,0-.61,4.71,17.15,17.15,0,0,0,.41,3.71L24.47,57.84a20.6,20.6,0,0,0-3.92-.39C9.46,57.45.48,66,.48,76.44s9,19,20.07,19,20.08-8.5,20.08-19a18.57,18.57,0,0,0-.41-3.71L49,64.44l3.84,3.63a1.75,1.75,0,0,0,2.36,0l.84-.8a2,2,0,0,1,2.65,0,1.7,1.7,0,0,1,0,2.51h0l-.84.79a1.52,1.52,0,0,0,0,2.23l20,18.88a14.06,14.06,0,0,0,19.1.08A12.29,12.29,0,0,0,97,73.71a.6.6,0,0,1-.08-.08l-20-18.88a1.74,1.74,0,0,0-2.37,0l-.83.79a2,2,0,0,1-2.66,0,1.71,1.71,0,0,1,0-2.51h0l.84-.79a1.53,1.53,0,0,0,0-2.24l-3.83-3.63,8.77-8.29A20.59,20.59,0,0,0,80.78,38.46Zm6.57,53.81a10.74,10.74,0,0,1-3.56-.61L96.86,79.29a9.47,9.47,0,0,1-5.93,12.37A10.86,10.86,0,0,1,87.35,92.27ZM68.4,51.14a4.75,4.75,0,0,0,.64,7,5.46,5.46,0,0,0,6.72,0L94.53,75.87c.2.19.39.39.58.6L80.81,90a6.64,6.64,0,0,1-.64-.55L61.38,71.68a4.76,4.76,0,0,0-.65-7,5.44,5.44,0,0,0-6.71,0l-2.68-2.54L65.72,48.61Zm-31.2,20a1.54,1.54,0,0,0-.44,1.51c2.29,8.53-3.15,17.2-12.17,19.37S6.41,89,4.12,80.48s3.15-17.2,12.16-19.37a17.69,17.69,0,0,1,8.31,0,1.76,1.76,0,0,0,1.59-.42L64.13,24.8a1.53,1.53,0,0,0,.43-1.51c-2.27-8.42,3.1-17,12-19.16a17.52,17.52,0,0,1,5.16-.46L72.9,12a1.52,1.52,0,0,0-.4,1.62l3.34,9.5a1.65,1.65,0,0,0,1.06,1l10,3.16a1.75,1.75,0,0,0,1.71-.38l8.82-8.35q0,.45,0,.9c0,8.7-7.36,15.78-16.55,15.83a17.59,17.59,0,0,1-4.22-.5,1.77,1.77,0,0,0-1.59.42h0" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bac_validation'" viewBox="0 0 112.56 110.09">
    <defs>
      <style>
        .cls-1 {
          stroke-width: 0.95px;
        }



        .cls-1,
        .cls-3 {
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
        }

        .cls-2,
        .cls-3 {
          stroke-width: 4.75px;
        }

        .cls-3 {
          fill: none;
        }
      </style>
    </defs>
    <title>-Fichier 2kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M.7,9.18,7.39,20.26a1.61,1.61,0,0,0,1,.75l6.25,1.48L36.09,42.74l2.37-2.23L16.71,19.93a1.73,1.73,0,0,0-.78-.41l-6-1.43L4.23,8.66,9.12,4l10,5.4,1.51,5.67a1.49,1.49,0,0,0,.44.74L42.79,36.41l2.37-2.23L23.75,13.92,22.18,8a1.56,1.56,0,0,0-.79-1L9.68.7a1.74,1.74,0,0,0-2,.25L1,7.28A1.51,1.51,0,0,0,.7,9.18Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M27,67.72A1.67,1.67,0,0,0,25.57,67h-10a1.67,1.67,0,0,0-1.43.77l-5,7.91a1.5,1.5,0,0,0,0,1.63l5,7.91a1.67,1.67,0,0,0,1.43.77h10A1.67,1.67,0,0,0,27,85.17l5-7.91a1.5,1.5,0,0,0,0-1.63Zm-2.38,15H16.48l-4-6.33,4-6.33h8.14l4,6.33Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M80.78,38.46c11,0,20-8.41,20.07-18.86a17.53,17.53,0,0,0-.62-4.72,1.72,1.72,0,0,0-2.8-.74L87,24l-8.27-2.61L76,13.57,86.41,3.71a1.52,1.52,0,0,0,0-2.23,1.65,1.65,0,0,0-.78-.42C74.91-1.51,64,4.63,61.31,14.76a18.28,18.28,0,0,0-.61,4.71,17.15,17.15,0,0,0,.41,3.71L24.47,57.84a20.6,20.6,0,0,0-3.92-.39C9.46,57.45.48,66,.48,76.44s9,19,20.07,19,20.08-8.5,20.08-19a18.57,18.57,0,0,0-.41-3.71L49,64.44l3.84,3.63a1.75,1.75,0,0,0,2.36,0l.84-.8a2,2,0,0,1,2.65,0,1.7,1.7,0,0,1,0,2.51h0l-.84.79a1.52,1.52,0,0,0,0,2.23l20,18.88a14.06,14.06,0,0,0,19.1.08A12.29,12.29,0,0,0,97,73.71a.6.6,0,0,1-.08-.08l-20-18.88a1.74,1.74,0,0,0-2.37,0l-.83.79a2,2,0,0,1-2.66,0,1.71,1.71,0,0,1,0-2.51h0l.84-.79a1.53,1.53,0,0,0,0-2.24l-3.83-3.63,8.77-8.29A20.59,20.59,0,0,0,80.78,38.46Zm6.57,53.81a10.74,10.74,0,0,1-3.56-.61L96.86,79.29a9.47,9.47,0,0,1-5.93,12.37A10.86,10.86,0,0,1,87.35,92.27ZM68.4,51.14a4.75,4.75,0,0,0,.64,7,5.46,5.46,0,0,0,6.72,0L94.53,75.87c.2.19.39.39.58.6L80.81,90a6.64,6.64,0,0,1-.64-.55L61.38,71.68a4.76,4.76,0,0,0-.65-7,5.44,5.44,0,0,0-6.71,0l-2.68-2.54L65.72,48.61Zm6.75-15.92L37.2,71.11a1.54,1.54,0,0,0-.44,1.51c2.29,8.53-3.15,17.2-12.17,19.37S6.41,89,4.12,80.48s3.15-17.2,12.16-19.37a17.69,17.69,0,0,1,8.31,0,1.76,1.76,0,0,0,1.59-.42L64.13,24.8a1.53,1.53,0,0,0,.43-1.51c-2.27-8.42,3.1-17,12-19.16a17.52,17.52,0,0,1,5.16-.46L72.9,12a1.52,1.52,0,0,0-.4,1.62l3.34,9.5a1.65,1.65,0,0,0,1.06,1l10,3.16a1.75,1.75,0,0,0,1.71-.38l8.82-8.35q0,.45,0,.9c0,8.7-7.36,15.78-16.55,15.83a17.59,17.59,0,0,1-4.22-.5,1.77,1.77,0,0,0-1.59.42Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M87,80.07l-2.37,2.24L67.88,66.48l2.37-2.23Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="76.93" cy="74.47" r="33.25" />
        <polyline class="cls-3" [ngStyle]="{'stroke': color}" points="59.73 74.45 72.08 85.85 93.93 64" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bac_stock'" viewBox="0 0 167.24 136.27">
    <defs>
      <style>
        .cls-1 {
          stroke: none;
        }
      </style>
    </defs>
    <title>-Fichier 3kerlog</title>
    <g id="Calque_2" data-name="Calque 2" [ngStyle]="{'fill': color}">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M43.83,79.44H32.55V75.16a2.06,2.06,0,0,0-2.06-2.06H15.4a2.06,2.06,0,0,0-2.06,2.06v4.28H2.06A2.06,2.06,0,0,0,0,81.5v6.33a2.06,2.06,0,0,0,2.06,2.06h.63L4.57,134.3a2.05,2.05,0,0,0,2.06,2H39.27a2.05,2.05,0,0,0,2-2l1.89-44.41h.62a2.06,2.06,0,0,0,2.06-2.06V81.5A2.06,2.06,0,0,0,43.83,79.44ZM17.46,77.22h11v2.22h-11Zm19.83,54.93H8.6L6.81,89.89H39.08Zm4.48-46.38H4.12V83.56H41.77Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M14.66,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,1,0,4.12,0V98.27A2.06,2.06,0,0,0,14.66,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M23,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,23,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M31.23,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,31.23,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M104.51,79.44H93.22V75.16a2.06,2.06,0,0,0-2.06-2.06H76.08A2.06,2.06,0,0,0,74,75.16v4.28H62.73a2.05,2.05,0,0,0-2,2.06v6.33a2.05,2.05,0,0,0,2,2.06h.63l1.88,44.41a2.07,2.07,0,0,0,2.06,2H99.94a2.07,2.07,0,0,0,2.06-2l1.88-44.41h.63a2.06,2.06,0,0,0,2.06-2.06V81.5A2.06,2.06,0,0,0,104.51,79.44ZM78.14,77.22h11v2.22h-11ZM98,132.15H69.28l-1.8-42.26H99.76Zm4.48-46.38H64.79V83.56h37.66Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M75.33,96.21a2.05,2.05,0,0,0-2,2.06v25.5a2.06,2.06,0,1,0,4.11,0V98.27A2.06,2.06,0,0,0,75.33,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M83.62,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,83.62,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M91.91,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,1,0,4.12,0V98.27A2.06,2.06,0,0,0,91.91,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M165.18,79.44H153.9V75.16a2.06,2.06,0,0,0-2.06-2.06H136.75a2.06,2.06,0,0,0-2.06,2.06v4.28H123.41a2.06,2.06,0,0,0-2.06,2.06v6.33a2.06,2.06,0,0,0,2.06,2.06H124l1.88,44.41a2.05,2.05,0,0,0,2.06,2h32.64a2.05,2.05,0,0,0,2-2l1.89-44.41h.62a2.06,2.06,0,0,0,2.06-2.06V81.5A2.06,2.06,0,0,0,165.18,79.44Zm-26.37-2.22h11v2.22h-11Zm19.83,54.93H130l-1.79-42.26h32.27Zm4.48-46.38H125.47V83.56h37.65Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M136,96.21A2.06,2.06,0,0,0,134,98.27v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,136,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M144.3,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,144.3,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M152.58,96.21a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V98.27A2.06,2.06,0,0,0,152.58,96.21Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M73.07,6.34H61.79V2.06A2.06,2.06,0,0,0,59.73,0H44.64a2.06,2.06,0,0,0-2.06,2.06V6.34H31.3A2.06,2.06,0,0,0,29.24,8.4v6.33a2.06,2.06,0,0,0,2.06,2.06h.63l1.88,44.4a2.06,2.06,0,0,0,2.06,2H68.51a2.05,2.05,0,0,0,2-2l1.89-44.4h.62a2.06,2.06,0,0,0,2.06-2.06V8.4A2.06,2.06,0,0,0,73.07,6.34ZM46.7,4.12h11V6.34h-11ZM66.53,59.05H37.84L36.05,16.79H68.32ZM71,12.67H33.36V10.46H71Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M43.9,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,1,0,4.12,0V25.17A2.06,2.06,0,0,0,43.9,23.11Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M52.19,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V25.17A2.06,2.06,0,0,0,52.19,23.11Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M60.47,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,1,0,4.12,0V25.17A2.06,2.06,0,0,0,60.47,23.11Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M133.75,6.34H122.47V2.06A2.06,2.06,0,0,0,120.41,0H105.32a2.06,2.06,0,0,0-2.06,2.06V6.34H92A2.06,2.06,0,0,0,89.92,8.4v6.33A2.06,2.06,0,0,0,92,16.79h.62l1.88,44.4a2.07,2.07,0,0,0,2.06,2h32.64a2.06,2.06,0,0,0,2.06-2l1.88-44.4h.63a2.06,2.06,0,0,0,2.06-2.06V8.4A2.06,2.06,0,0,0,133.75,6.34ZM107.38,4.12h11V6.34h-11Zm19.83,54.93H98.52l-1.8-42.26H129Zm4.48-46.38H94V10.46h37.65Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M104.58,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V25.17A2.06,2.06,0,0,0,104.58,23.11Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M112.86,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,0,0,4.12,0V25.17A2.06,2.06,0,0,0,112.86,23.11Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M121.15,23.11a2.06,2.06,0,0,0-2.06,2.06v25.5a2.06,2.06,0,1,0,4.12,0V25.17A2.06,2.06,0,0,0,121.15,23.11Z" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bennes_contenant'" viewBox="0 0 115.17 98.19">
    <defs>
      <style>
      </style>
    </defs>
    <title>-Fichier 4kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M1.61,53.44A2.4,2.4,0,0,0,.16,56.55L4.72,69.09a1.11,1.11,0,0,0,.6.75L29.85,97.37a2.29,2.29,0,0,0,2.52.7l81.19-29.56A2.39,2.39,0,0,0,115,65.4L98.53,20.1l9.4-3.42a2.39,2.39,0,0,0,1.45-3.11L105,1.61A2.39,2.39,0,0,0,101.91.16L81.4,7.62C77.7,9,82,13.56,84.51,23.27Zm3.65,3.84L88.45,27a2.4,2.4,0,0,0,1.45-3.11L85.34,11.35l16.24-5.91,2.8,7.69L95,16.56a2.39,2.39,0,0,0-1.45,3.11L110,65,32.24,93.27l-23.35-26Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M85.58,37.72l4.56-1.66.39.18,5.26,24.22a2,2,0,0,0,2.54,1.66l.29-.11A2,2,0,0,0,100,59.58L94.72,35.36a4.79,4.79,0,0,0-6.42-3.47l-4.56,1.66a2.4,2.4,0,0,0-1.45,3.11C82.81,38.09,84.44,38.14,85.58,37.72Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M69.34,43.63,73.9,42l.39.18,5.26,24.22A1.94,1.94,0,0,0,82.09,68l.29-.1a2,2,0,0,0,1.37-2.44L78.48,41.27a4.79,4.79,0,0,0-6.42-3.47L67.5,39.46a2.4,2.4,0,0,0-1.45,3.11C66.57,44,68.2,44.05,69.34,43.63Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M53.1,49.54l4.56-1.66.39.19,5.26,24.21a1.94,1.94,0,0,0,2.54,1.66l.29-.1a2,2,0,0,0,1.37-2.44L62.24,47.18a4.79,4.79,0,0,0-6.42-3.47l-4.56,1.66a2.4,2.4,0,0,0-1.45,3.11C50.33,49.91,52,50,53.1,49.54Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M36.86,55.45l4.56-1.66.39.19,5.26,24.21a1.94,1.94,0,0,0,2.54,1.66l.29-.1a2,2,0,0,0,1.37-2.44L46,53.09a4.79,4.79,0,0,0-6.42-3.47l-4.27,1.56a2.39,2.39,0,0,0-1.45,3.11A2.14,2.14,0,0,0,36.86,55.45Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M25.67,60.17l5.27,24.22a2,2,0,0,0,2.54,1.66l.28-.11a2,2,0,0,0,1.37-2.43L29.87,59.29a4.79,4.79,0,0,0-6.43-3.47l-4.55,1.66a2.39,2.39,0,0,0-1.45,3.11A2.23,2.23,0,0,0,20.55,62l4.55-1.66Z" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bennes_planning'" viewBox="0 0 74.26 69.67">
    <defs>
      <style>
        .cls-1,
        .cls-2 {}

        .cls-1 {
          stroke-miterlimit: 10;
          stroke-width: 2.61px;
        }

        .cls-2 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 4.75px;
        }
      </style>
    </defs>
    <title>-Fichier 5kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-121" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M66.25,6.48H63.73V3.81a2.5,2.5,0,0,0-2.5-2.5H59.16a2.5,2.5,0,0,0-2.5,2.5V6.48H17.34V3.81a2.5,2.5,0,0,0-2.5-2.5H12.77a2.51,2.51,0,0,0-2.51,2.5V6.48H8a6.75,6.75,0,0,0-6.7,6.79V61.58A6.74,6.74,0,0,0,8,68.36H60.92L73,56V13.27A6.76,6.76,0,0,0,66.25,6.48ZM58.56,3.81a.6.6,0,0,1,.6-.6h2.07a.6.6,0,0,1,.6.6v7.24a.6.6,0,0,1-.6.6H59.16a.6.6,0,0,1-.6-.6Zm-46.4,0a.6.6,0,0,1,.61-.6h2.07a.6.6,0,0,1,.6.6v7.24a.6.6,0,0,1-.6.6H12.77a.6.6,0,0,1-.61-.6ZM8,8.38h2.25v2.67a2.51,2.51,0,0,0,2.51,2.5h2.07a2.5,2.5,0,0,0,2.5-2.5V8.38H56.66v2.67a2.5,2.5,0,0,0,2.5,2.5h2.07a2.5,2.5,0,0,0,2.5-2.5V8.38h2.52a4.86,4.86,0,0,1,4.81,4.89V22H3.21V13.27A4.85,4.85,0,0,1,8,8.38ZM3.21,61.57V23.92H71.06V53.57H59.3a1,1,0,0,0-.95,1V66.46H8A4.85,4.85,0,0,1,3.21,61.57Zm57,4.75V55.47H70.81Z" />
        <polyline class="cls-2" [ngStyle]="{'stroke': color}" points="20.51 43.86 32.86 55.26 54.71 33.41" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'bennes_retour'" viewBox="0 0 101.66 107.12">
    <defs>
      <style>
        .cls-1 {}

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
          stroke-width: 4.75px;
        }
      </style>
    </defs>
    <title>-Fichier 6kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M48.5,4.85H4.85V87.3H67.9v-63h-17a2.43,2.43,0,0,1-2.42-2.42Zm4.85,3.43V19.4H64.47ZM0,2.42A2.43,2.43,0,0,1,2.42,0h48.5a2.45,2.45,0,0,1,1.72.71L72,20.11a2.45,2.45,0,0,1,.71,1.72v67.9a2.43,2.43,0,0,1-2.43,2.42H2.42A2.43,2.43,0,0,1,0,89.73Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="66.03" cy="71.49" r="33.25" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M41.74,69.31,55.62,63l13.77-6.49a2.38,2.38,0,0,1,3.13,1.12,1.79,1.79,0,0,1,.23,1.12v3.8H89.32a2.3,2.3,0,0,1,2.35,2.35V78a2.39,2.39,0,0,1-2.35,2.46H72.75v3.81a2.3,2.3,0,0,1-2.35,2.35,1.63,1.63,0,0,1-1-.23L55.62,80.05,41.74,73.67a2.38,2.38,0,0,1-1.12-3.13A3,3,0,0,1,41.74,69.31Zm31-2-.11,1v3.25l.11,4.14H87v-8.4Zm-15.11,0-9.18,4.26,9.18,4.14h0l10.41,4.92-.12-9.06h0l.12-9.18L57.64,67.29Z" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'grc_suivi'" viewBox="0 0 107.9 107.9">
    <defs>
      <style>
        .cls-1 {
          stroke-miterlimit: 10;
          stroke-width: 1.04px;
        }
      </style>
    </defs>
    <title>-Fichier 7kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path id="Shape" class="cls-1" [ngStyle]="{'fill': color, 'stroke':color}"
          d="M98.47.52H20.11a8.92,8.92,0,0,0-8.72,7.13H7.65a7.12,7.12,0,1,0,0,14.24h3.56v5.35H7.65a7.12,7.12,0,1,0,0,14.24h3.56v5.34H7.65a7.13,7.13,0,1,0,0,14.25h3.56v5.34H7.65a7.13,7.13,0,1,0,0,14.25h3.56V86H7.65a7.13,7.13,0,1,0,0,14.25h3.74a8.91,8.91,0,0,0,8.72,7.12H98.47a8.91,8.91,0,0,0,8.9-8.9v-89A8.92,8.92,0,0,0,98.47.52ZM4.08,14.77a3.57,3.57,0,0,1,3.57-3.56H18.33a3.56,3.56,0,1,1,0,7.12H7.65A3.57,3.57,0,0,1,4.08,14.77Zm0,19.59A3.57,3.57,0,0,1,7.65,30.8H18.33a3.56,3.56,0,1,1,0,7.12H7.65A3.58,3.58,0,0,1,4.08,34.36ZM4.08,54a3.57,3.57,0,0,1,3.57-3.56H18.33a3.56,3.56,0,1,1,0,7.12H7.65A3.58,3.58,0,0,1,4.08,54Zm0,19.59A3.57,3.57,0,0,1,7.65,70H18.33a3.56,3.56,0,0,1,0,7.12H7.65A3.58,3.58,0,0,1,4.08,73.54Zm0,19.59a3.57,3.57,0,0,1,3.57-3.56H18.33a3.56,3.56,0,0,1,0,7.12H7.65A3.58,3.58,0,0,1,4.08,93.13Zm11,7.12h3.23a7.13,7.13,0,0,0,0-14.25H14.77V80.66h3.56a7.13,7.13,0,0,0,0-14.25H14.77V61.07h3.56a7.13,7.13,0,0,0,0-14.25H14.77V41.48h3.56a7.12,7.12,0,1,0,0-14.24H14.77V21.89h3.56a7.12,7.12,0,1,0,0-14.24H15.1a5.34,5.34,0,0,1,5-3.57H29v99.73H20.11A5.32,5.32,0,0,1,15.1,100.25Zm88.71-1.78a5.34,5.34,0,0,1-5.34,5.34H32.58V4.08H98.47a5.35,5.35,0,0,1,5.34,5.35Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke':color}"
          d="M68.19,21.89a32,32,0,0,0-23.85,53.4,1.78,1.78,0,0,0,.52.57,31.92,31.92,0,0,0,46.67,0,1.78,1.78,0,0,0,.52-.57,32,32,0,0,0-23.86-53.4Zm0,60.55a28.39,28.39,0,0,1-20.26-8.5,21.34,21.34,0,0,1,40.53,0A28.39,28.39,0,0,1,68.19,82.44ZM57.51,45A10.69,10.69,0,1,1,68.19,55.73,10.68,10.68,0,0,1,57.51,45Zm33.58,25.8A25,25,0,0,0,76,57a14.25,14.25,0,1,0-15.51,0A25,25,0,0,0,45.3,70.84a28.5,28.5,0,1,1,45.79,0Z" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'grc_devis'" xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1" id="Calque_1" x="0px" y="0px" viewBox="0 0 101.7 107.1" style="enable-background:new 0 0 101.7 107.1;"
    xml:space="preserve">
    <style type="text/css">
      .st0 {}

      .st1 {
        fill: #FFFFFF;
        stroke-width: 4.75;
        stroke-miterlimit: 10;
      }

      .st2 {
        enable-background: new;
      }
    </style>
    <title>-Fichier 8kerlog</title>
    <g>
      <g id="Calque_2-2">
        <path class="st0" [ngStyle]="{'fill': color}"
          d="M48.5,4.8H4.8v82.5h63.1v-63h-17c-1.3,0-2.4-1.1-2.4-2.4L48.5,4.8z M53.3,8.3v11.1h11.1L53.3,8.3z M0,2.4    C0,1.1,1.1,0,2.4,0h48.5c0.6,0,1.3,0.3,1.7,0.7L72,20.1c0.5,0.5,0.7,1.1,0.7,1.7v67.9c0,1.3-1.1,2.4-2.4,2.4H2.4    c-1.3,0-2.4-1.1-2.4-2.4V2.4z" />
        <circle class="st1" [ngStyle]="{'stroke': color}" cx="66" cy="71.5" r="33.2" />
        <g class="st2">
          <path class="st0" [ngStyle]="{'fill': color}"
            d="M57.4,85.5v-27h9.8c2.2,0,4.1,0.4,5.8,1.1s3,1.7,4.2,2.9c1.1,1.2,2,2.6,2.5,4.3c0.6,1.6,0.8,3.4,0.8,5.2     c0,2.1-0.3,3.9-0.9,5.6c-0.6,1.7-1.5,3.1-2.7,4.3c-1.2,1.2-2.6,2.1-4.2,2.7c-1.6,0.6-3.5,1-5.5,1H57.4z M75.2,72     c0-1.3-0.2-2.5-0.5-3.6c-0.4-1.1-0.9-2-1.6-2.8c-0.7-0.8-1.5-1.4-2.5-1.8c-1-0.4-2.1-0.6-3.4-0.6h-4.6v17.8h4.6     c1.3,0,2.4-0.2,3.4-0.7c1-0.5,1.8-1.1,2.5-1.9c0.7-0.8,1.2-1.7,1.5-2.8C75,74.4,75.2,73.2,75.2,72z" />
        </g>
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'contrat_appro'" viewBox="0 0 101.66 107.12">
    <defs>
      <style>
        .cls-1 {}

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
        }

        .cls-2,
        .cls-3 {
          stroke-width: 4.75px;
        }

        .cls-3 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
      </style>
    </defs>
    <title>-Fichier 9kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M48.5,4.85H4.85V87.3H67.9v-63h-17a2.43,2.43,0,0,1-2.42-2.42Zm4.85,3.43V19.4H64.47ZM0,2.43A2.43,2.43,0,0,1,2.42,0h48.5a2.45,2.45,0,0,1,1.72.71L72,20.11a2.45,2.45,0,0,1,.71,1.72V89.72a2.43,2.43,0,0,1-2.43,2.43H2.42A2.43,2.43,0,0,1,0,89.72Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="66.03" cy="71.49" r="33.25" />
        <polyline class="cls-3" [ngStyle]="{'stroke': color}" points="48.83 71.47 61.18 82.88 83.03 61.02" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'contrat_expedition'" viewBox="0 0 101.66 107.12">
    <defs>
      <style>
        .cls-1 {}

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
          stroke-width: 4.75px;
        }
      </style>
    </defs>
    <title>-Fichier 10kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M48.5,4.85H4.85V87.3H67.9v-63h-17a2.43,2.43,0,0,1-2.42-2.42Zm4.85,3.43V19.4H64.47ZM0,2.43A2.43,2.43,0,0,1,2.42,0h48.5a2.45,2.45,0,0,1,1.72.71L72,20.11a2.45,2.45,0,0,1,.71,1.72V89.72a2.43,2.43,0,0,1-2.43,2.43H2.42A2.43,2.43,0,0,1,0,89.72Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="66.03" cy="71.49" r="33.25" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M93.35,70.54a2.38,2.38,0,0,1-1.12,3.13L78.35,80.05,64.58,86.43a1.63,1.63,0,0,1-1,.23,2.3,2.3,0,0,1-2.35-2.35V80.5H44.65A2.39,2.39,0,0,1,42.3,78V64.94a2.3,2.3,0,0,1,2.35-2.35H61.22v-3.8a1.86,1.86,0,0,1,.22-1.12,2.39,2.39,0,0,1,3.14-1.12L78.35,63l13.88,6.27A3,3,0,0,1,93.35,70.54ZM47,67.29v8.4H61.22l.11-4.14V68.3l-.11-1Zm29.33,0h0L65.92,62.37,66,71.55h0l-.11,9.06,10.41-4.92h0l9.18-4.14-9.18-4.26Z" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'contrat_fact'" viewBox="0 0 101.66 107.12">
    <defs>
      <style>
        .cls-1 {}

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
          stroke-width: 4.75px;
        }
      </style>
    </defs>
    <title>-Fichier 11kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M48.5,4.85H4.85V87.3H67.9v-63h-17a2.43,2.43,0,0,1-2.42-2.43Zm4.85,3.43V19.4H64.47ZM0,2.42A2.43,2.43,0,0,1,2.42,0h48.5a2.45,2.45,0,0,1,1.72.71L72,20.11a2.45,2.45,0,0,1,.71,1.71v67.9a2.43,2.43,0,0,1-2.43,2.43H2.42A2.43,2.43,0,0,1,0,89.72Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="66.03" cy="71.49" r="33.25" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M72.07,61.11a2.28,2.28,0,0,0,1.21-4.4A16,16,0,0,0,54.6,65.27h-3a2.28,2.28,0,1,0,0,4.56h1.62a16.47,16.47,0,0,0-.11,3.65H51.62a2.28,2.28,0,1,0,0,4.56h2.59a16,16,0,0,0,19.07,9.45,2.28,2.28,0,0,0-1.21-4.4A11.42,11.42,0,0,1,59.3,78h7.22a2.28,2.28,0,0,0,0-4.56h-8.8a11.76,11.76,0,0,1,.14-3.65H69.52a2.28,2.28,0,0,0,0-4.56H59.91a11.38,11.38,0,0,1,12.16-4.16Z" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'fact_gestion'" xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1" id="Calque_1" x="0px" y="0px" viewBox="0 0 101.7 107.1" style="enable-background:new 0 0 101.7 107.1;"
    xml:space="preserve">
    <style type="text/css">
      .st0 {}

      .st1 {
        fill: #FFFFFF;
        stroke-width: 4.75;
        stroke-miterlimit: 10;
      }

      .st2 {
        enable-background: new;
      }
    </style>
    <title>-Fichier 12kerlog</title>
    <g>
      <g id="Calque_2-2">
        <path class="st0" [ngStyle]="{'fill': color}"
          d="M48.5,4.8H4.8v82.5h63.1v-63h-17c-1.3,0-2.4-1.1-2.4-2.4L48.5,4.8z M53.3,8.3v11.1h11.1L53.3,8.3z M0,2.4    C0,1.1,1.1,0,2.4,0h48.5c0.6,0,1.3,0.3,1.7,0.7L72,20.1c0.5,0.5,0.7,1.1,0.7,1.7v67.9c0,1.3-1.1,2.4-2.4,2.4H2.4    c-1.3,0-2.4-1.1-2.4-2.4V2.4z" />
        <circle class="st1" [ngStyle]="{'stroke': color}" cx="66" cy="71.5" r="33.2" />
        <g class="st2">
          <path class="st0" [ngStyle]="{'fill': color}"
            d="M79.1,78.5c0,1.1-0.2,2.1-0.7,3c-0.5,0.9-1.1,1.6-1.9,2.2c-0.8,0.6-1.7,1-2.8,1.3c-1.1,0.3-2.2,0.5-3.4,0.5     h-13v-27h14.4c0.9,0,1.8,0.2,2.5,0.6c0.8,0.4,1.4,0.9,1.9,1.6s0.9,1.4,1.2,2.2c0.3,0.8,0.4,1.7,0.4,2.5c0,1.3-0.3,2.6-1,3.7     s-1.6,2-2.9,2.6c1.5,0.5,2.8,1.3,3.7,2.5S79.1,76.8,79.1,78.5z M62.6,63v6.8h7c0.9,0,1.6-0.3,2.3-0.9c0.6-0.6,0.9-1.4,0.9-2.5     c0-1-0.3-1.9-0.9-2.5c-0.6-0.6-1.3-0.9-2.1-0.9H62.6z M73.8,77.6c0-0.5-0.1-0.9-0.2-1.4c-0.2-0.4-0.4-0.8-0.7-1.2     c-0.3-0.3-0.6-0.6-1-0.8c-0.4-0.2-0.8-0.3-1.3-0.3h-8.1v7.1h7.8c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.4,1.1-0.7     c0.3-0.3,0.5-0.7,0.7-1.1C73.7,78.5,73.8,78,73.8,77.6z" />
        </g>
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'fact_ventes'" xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1" id="Calque_1" x="0px" y="0px" viewBox="0 0 101.7 107.1" style="enable-background:new 0 0 101.7 107.1;"
    xml:space="preserve">
    <style type="text/css">
      .st0 {}

      .st1 {
        fill: #FFFFFF;
        stroke-width: 4.75;
        stroke-miterlimit: 10;
      }

      .st2 {
        enable-background: new;
      }
    </style>
    <title>-Fichier 13kerlog</title>
    <g>
      <g id="Calque_2-2">
        <path class="st0" [ngStyle]="{'fill': color}"
          d="M48.5,4.8H4.8v82.5h63.1v-63h-17c-1.3,0-2.4-1.1-2.4-2.4L48.5,4.8z M53.3,8.3v11.1h11.1L53.3,8.3z M0,2.4    C0,1.1,1.1,0,2.4,0h48.5c0.6,0,1.3,0.3,1.7,0.7L72,20.1c0.5,0.5,0.7,1.1,0.7,1.7v67.9c0,1.3-1.1,2.4-2.4,2.4H2.4    c-1.3,0-2.4-1.1-2.4-2.4V2.4z" />
        <circle class="st1" [ngStyle]="{'stroke': color}" cx="66" cy="71.5" r="33.2" />
        <g class="st2">
          <path class="st0" [ngStyle]="{'fill': color}"
            d="M59.1,58.5l7.3,20.4l7.2-20.4h5.5l-10.5,27h-4.4l-10.6-27H59.1z" />
        </g>
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'fact_paiement'" viewBox="0 0 101.66 107.12">
    <defs>
      <style>
        .cls-1 {}

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
          stroke-width: 4.75px;
        }
      </style>
    </defs>
    <title>-Fichier 11kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M48.5,4.85H4.85V87.3H67.9v-63h-17a2.43,2.43,0,0,1-2.42-2.43Zm4.85,3.43V19.4H64.47ZM0,2.42A2.43,2.43,0,0,1,2.42,0h48.5a2.45,2.45,0,0,1,1.72.71L72,20.11a2.45,2.45,0,0,1,.71,1.71v67.9a2.43,2.43,0,0,1-2.43,2.43H2.42A2.43,2.43,0,0,1,0,89.72Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="66.03" cy="71.49" r="33.25" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M72.07,61.11a2.28,2.28,0,0,0,1.21-4.4A16,16,0,0,0,54.6,65.27h-3a2.28,2.28,0,1,0,0,4.56h1.62a16.47,16.47,0,0,0-.11,3.65H51.62a2.28,2.28,0,1,0,0,4.56h2.59a16,16,0,0,0,19.07,9.45,2.28,2.28,0,0,0-1.21-4.4A11.42,11.42,0,0,1,59.3,78h7.22a2.28,2.28,0,0,0,0-4.56h-8.8a11.76,11.76,0,0,1,.14-3.65H69.52a2.28,2.28,0,0,0,0-4.56H59.91a11.38,11.38,0,0,1,12.16-4.16Z" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'loc_planning'" viewBox="0 0 111 111">
    <defs>
      <style>
        .cls-1 {}
      </style>
    </defs>
    <title>-Fichier 14kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M101.75,66V18.5A9.26,9.26,0,0,0,92.5,9.25H78.62V2.31a2.31,2.31,0,0,0-4.62,0V9.25H32.37V2.31a2.31,2.31,0,1,0-4.62,0V9.25H9.25A9.26,9.26,0,0,0,0,18.5v74a9.26,9.26,0,0,0,9.25,9.25H66A25.42,25.42,0,1,0,101.75,66ZM4.62,18.5a4.63,4.63,0,0,1,4.63-4.62h18.5V18.5a4.63,4.63,0,1,0,4.62,4.62V13.88H74V18.5a4.63,4.63,0,1,0,4.62,4.62V13.88H92.5a4.62,4.62,0,0,1,4.62,4.62V32.37H4.62ZM9.25,97.12A4.62,4.62,0,0,1,4.63,92.5V37H97.12V62.93A25.4,25.4,0,0,0,62.93,97.12Zm76.31,9.26a20.82,20.82,0,1,1,20.82-20.82A20.84,20.84,0,0,1,85.56,106.38Z" />
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M87.87,84.6V71.69a2.31,2.31,0,0,0-4.62,0V85.56a2.3,2.3,0,0,0,.68,1.64l6.93,6.94a2.32,2.32,0,0,0,3.28-3.27Z" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'loc_validation'" viewBox="0 0 112.56 110.09">
    <defs>
      <style>
        .cls-1 {
          stroke-width: 0.95px;
        }

        .cls-1,
        .cls-2,
        .cls-3 {}

        .cls-1,
        .cls-3 {
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .cls-2 {
          fill: #fff;
          stroke-miterlimit: 10;
        }

        .cls-2,
        .cls-3 {
          stroke-width: 4.75px;
        }

        .cls-3 {
          fill: none;
        }
      </style>
    </defs>
    <title>-Fichier 2kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M.7,9.18,7.39,20.26a1.61,1.61,0,0,0,1,.75l6.25,1.48L36.09,42.74l2.37-2.23L16.71,19.93a1.73,1.73,0,0,0-.78-.41l-6-1.43L4.23,8.66,9.12,4l10,5.4,1.51,5.67a1.49,1.49,0,0,0,.44.74L42.79,36.41l2.37-2.23L23.75,13.92,22.18,8a1.56,1.56,0,0,0-.79-1L9.68.7a1.74,1.74,0,0,0-2,.25L1,7.28A1.51,1.51,0,0,0,.7,9.18Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M27,67.72A1.67,1.67,0,0,0,25.57,67h-10a1.67,1.67,0,0,0-1.43.77l-5,7.91a1.5,1.5,0,0,0,0,1.63l5,7.91a1.67,1.67,0,0,0,1.43.77h10A1.67,1.67,0,0,0,27,85.17l5-7.91a1.5,1.5,0,0,0,0-1.63Zm-2.38,15H16.48l-4-6.33,4-6.33h8.14l4,6.33Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M80.78,38.46c11,0,20-8.41,20.07-18.86a17.53,17.53,0,0,0-.62-4.72,1.72,1.72,0,0,0-2.8-.74L87,24l-8.27-2.61L76,13.57,86.41,3.71a1.52,1.52,0,0,0,0-2.23,1.65,1.65,0,0,0-.78-.42C74.91-1.51,64,4.63,61.31,14.76a18.28,18.28,0,0,0-.61,4.71,17.15,17.15,0,0,0,.41,3.71L24.47,57.84a20.6,20.6,0,0,0-3.92-.39C9.46,57.45.48,66,.48,76.44s9,19,20.07,19,20.08-8.5,20.08-19a18.57,18.57,0,0,0-.41-3.71L49,64.44l3.84,3.63a1.75,1.75,0,0,0,2.36,0l.84-.8a2,2,0,0,1,2.65,0,1.7,1.7,0,0,1,0,2.51h0l-.84.79a1.52,1.52,0,0,0,0,2.23l20,18.88a14.06,14.06,0,0,0,19.1.08A12.29,12.29,0,0,0,97,73.71a.6.6,0,0,1-.08-.08l-20-18.88a1.74,1.74,0,0,0-2.37,0l-.83.79a2,2,0,0,1-2.66,0,1.71,1.71,0,0,1,0-2.51h0l.84-.79a1.53,1.53,0,0,0,0-2.24l-3.83-3.63,8.77-8.29A20.59,20.59,0,0,0,80.78,38.46Zm6.57,53.81a10.74,10.74,0,0,1-3.56-.61L96.86,79.29a9.47,9.47,0,0,1-5.93,12.37A10.86,10.86,0,0,1,87.35,92.27ZM68.4,51.14a4.75,4.75,0,0,0,.64,7,5.46,5.46,0,0,0,6.72,0L94.53,75.87c.2.19.39.39.58.6L80.81,90a6.64,6.64,0,0,1-.64-.55L61.38,71.68a4.76,4.76,0,0,0-.65-7,5.44,5.44,0,0,0-6.71,0l-2.68-2.54L65.72,48.61Zm6.75-15.92L37.2,71.11a1.54,1.54,0,0,0-.44,1.51c2.29,8.53-3.15,17.2-12.17,19.37S6.41,89,4.12,80.48s3.15-17.2,12.16-19.37a17.69,17.69,0,0,1,8.31,0,1.76,1.76,0,0,0,1.59-.42L64.13,24.8a1.53,1.53,0,0,0,.43-1.51c-2.27-8.42,3.1-17,12-19.16a17.52,17.52,0,0,1,5.16-.46L72.9,12a1.52,1.52,0,0,0-.4,1.62l3.34,9.5a1.65,1.65,0,0,0,1.06,1l10,3.16a1.75,1.75,0,0,0,1.71-.38l8.82-8.35q0,.45,0,.9c0,8.7-7.36,15.78-16.55,15.83a17.59,17.59,0,0,1-4.22-.5,1.77,1.77,0,0,0-1.59.42Z" />
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M87,80.07l-2.37,2.24L67.88,66.48l2.37-2.23Z" />
        <circle class="cls-2" [ngStyle]="{'stroke': color}" cx="76.93" cy="74.47" r="33.25" />
        <polyline class="cls-3" [ngStyle]="{'stroke': color}" points="59.73 74.45 72.08 85.85 93.93 64" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'rh_personnel'" viewBox="0 0 96.31 72.14">
    <defs>
    </defs>
    <title>-Fichier 15kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2">
        <path class="cls-1" [ngStyle]="{'fill': color}"
          d="M82.78,21a12,12,0,1,0-17-.82,10.7,10.7,0,0,0,.83.82,21.65,21.65,0,0,0-3.71,2A14.11,14.11,0,1,0,40,35.93l-1.79.67a21.7,21.7,0,0,0-8.37-6.11,12,12,0,1,0-17-.78q.38.41.78.78A21.67,21.67,0,0,0,0,50.67v4.81a2.41,2.41,0,0,0,2.41,2.41H21.24a27.76,27.76,0,0,0-.44,4.81v7a2.41,2.41,0,0,0,2.41,2.41H74.74a2.4,2.4,0,0,0,2.4-2.41v-7a27.85,27.85,0,0,0-4-14.44H93.9a2.41,2.41,0,0,0,2.41-2.41V41A21.67,21.67,0,0,0,82.78,21ZM67.42,12.14a7.22,7.22,0,1,1,7.22,7.22A7.22,7.22,0,0,1,67.42,12.14ZM39.68,25.24a9.3,9.3,0,0,1,18.59,0h0a9.36,9.36,0,0,1-.39,2.46h0A9.14,9.14,0,0,1,55.28,32h0a9.3,9.3,0,0,1-15.6-6.79ZM14.45,21.77A7.22,7.22,0,1,1,21.67,29,7.22,7.22,0,0,1,14.45,21.77ZM4.82,53.07v-2.4A16.85,16.85,0,0,1,33.71,39,28.23,28.23,0,0,0,22.54,53.07ZM72.23,67.52H25.62V62.7a22.71,22.71,0,0,1,1.06-6.54h0a23.34,23.34,0,0,1,7.9-11.71h0a23.51,23.51,0,0,1,4-2.55h0A21.86,21.86,0,0,1,55,40.26h0a23.17,23.17,0,0,1,8.86,4.82h0a23.9,23.9,0,0,1,2.36,2.36h0a23.12,23.12,0,0,1,6,15.26ZM91.49,43.44h-22a28.26,28.26,0,0,0-10.88-7.17l.38-1.06a14.5,14.5,0,0,0,2-2.6h0a13.74,13.74,0,0,0,1.3-2.84h0A16.8,16.8,0,0,1,91.49,41Z" />
      </g>
    </g>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" *ngSwitchCase="'rh_heures'"
    viewBox="0 0 102 102">
    <defs>
      <!-- <style>
        .cls-1 {
          fill: #00604d;
          stroke: #00604d;
          stroke-miterlimit: 10;
        }
      </style> -->
    </defs>
    <title>-Fichier 16kerlog</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_2-2" data-name="Calque 2" [ngStyle]="{'fill': color, 'stroke': color}">
        <path class="cls-1" d="M51,17a2.21,2.21,0,0,0,2.2-2.2v-1.1a2.2,2.2,0,0,0-4.4,0v1.1A2.21,2.21,0,0,0,51,17Z" />
        <path class="cls-1" d="M51,85a2.21,2.21,0,0,0-2.2,2.2v1.1a2.2,2.2,0,0,0,4.4,0v-1.1A2.21,2.21,0,0,0,51,85Z" />
        <path class="cls-1" d="M14.77,48.8h-1.1a2.2,2.2,0,0,0,0,4.4h1.1a2.2,2.2,0,0,0,0-4.4Z" />
        <path class="cls-1" d="M88.33,48.8h-1.1a2.2,2.2,0,1,0,0,4.4h1.1a2.2,2.2,0,0,0,0-4.4Z" />
        <path class="cls-1"
          d="M26.19,23.12a2.17,2.17,0,0,0-3.07,3.07l.76.77A2.13,2.13,0,0,0,27,27a2.13,2.13,0,0,0,0-3.08Z" />
        <path class="cls-1"
          d="M23.88,75l-.76.77a2.2,2.2,0,0,0,1.53,3.73,2.17,2.17,0,0,0,1.54-.66l.77-.76A2.18,2.18,0,0,0,23.88,75Z" />
        <path class="cls-1"
          d="M75.81,23.12l-.77.76A2.13,2.13,0,0,0,75,27a2.13,2.13,0,0,0,3.08,0l.76-.77a2.17,2.17,0,0,0-3.07-3.07Z" />
        <path class="cls-1"
          d="M53.2,50.12v-20a2.2,2.2,0,0,0-4.4,0V51a2.17,2.17,0,0,0,.66,1.54l24.05,24a2.13,2.13,0,0,0,1.53.66,2.17,2.17,0,0,0,1.54-.66,2.12,2.12,0,0,0,0-3.07Z" />
        <path class="cls-1"
          d="M51,.5A50.5,50.5,0,1,0,101.5,51,50.51,50.51,0,0,0,51,.5Zm0,96.61A46.11,46.11,0,1,1,97.11,51,46.1,46.1,0,0,1,51,97.11Z" />
      </g>
    </g>
  </svg>

  <svg *ngSwitchCase="'camion'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 488 488" style="enable-background:new 0 0 488 488;"
    xml:space="preserve">
    <g transform="translate(0 -540.36)" style="fill:#5c92cd" [ngStyle]="{'fill': color, 'stroke': color}">
      <g>
        <g>
          <path
            d="M366.5,638.36c5.5,0,10-4.5,10-10s-4.5-10-10-10h-51.3c-4.7,0-8.8,3.2-9.8,7.8l-7.4,33.8H10c-5.5,0-10,4.5-10,10v187.2     c0,5.5,4.5,10,10,10h51.3c3.4,0,6.6-1.7,8.4-4.6l17.4-27h86.3v21.6c0,5.5,4.5,10,10,10h81.4c4.6,0,8.7-3.3,9.8-7.8l48.7-221     H366.5z M256.8,847.16h-63.4h-0.1v-21.6c0-5.5-4.5-10-10-10H81.6c-3.4,0-6.6,1.7-8.4,4.6l-17.4,27H20v-167.2h273.7L256.8,847.16z     " />
          <path
            d="M478,659.96H346.2c-4.7,0-8.8,3.3-9.8,7.9l-40.7,186.4c-0.6,3,0.1,6,2,8.4c1.9,2.3,4.8,3.7,7.8,3.7h30.1     c3.3,0,6.4-1.7,8.3-4.5l17.4-26.3h76.6v20.8c0,5.5,4.5,10,10,10H478c5.5,0,10-4.5,10-10v-186.4     C488,664.46,483.5,659.96,478,659.96z M468,846.36h-10.1v-20.8c0-5.5-4.5-10-10-10h-92c-3.3,0-6.4,1.7-8.3,4.5l-17.4,26.3h-12.3     l36.3-166.4H468V846.36z" />
          <path
            d="M122.3,847.16c-28.4,0-50.7,22.7-50.7,51.6c0,28.5,22.7,51.6,50.7,51.6s50.7-23.1,50.7-51.6     C173,869.86,150.7,847.16,122.3,847.16z M122.3,930.36c-16.9,0-30.7-14.2-30.7-31.6c0-17.7,13.5-31.6,30.7-31.6     c17.2,0,30.7,13.9,30.7,31.6C153,916.16,139.2,930.36,122.3,930.36z" />
          <path
            d="M396.6,847.16c-28,0-50.7,23.1-50.7,51.6c0,28,23.2,51.6,50.7,51.6c28,0,50.7-23.1,50.7-51.6     C447.3,869.86,425,847.16,396.6,847.16z M396.6,930.36c-16.4,0-30.7-14.8-30.7-31.6c0-17.4,13.8-31.6,30.7-31.6     c17.2,0,30.7,13.9,30.7,31.6C427.3,916.16,413.5,930.36,396.6,930.36z" />
          <path
            d="M366.5,773.16h81.4c5.5,0,10-4.5,10-10v-62.4c0-5.5-4.5-10-10-10h-71.6c-4.9,0-9.1,3.6-9.9,8.5l-9.8,62.4     c-0.4,2.8,0.4,5.8,2.3,8C360.8,771.86,363.6,773.16,366.5,773.16z M384.8,710.76h53.1v42.4h-59.7L384.8,710.76z" />
        </g>
      </g>
    </g>
  </svg>
  <!-- 
  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'camion'" xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1" id="Capa_1" x="0px" y="0px" width="936px" height="936px" viewBox="0 0 936 936"
    style="enable-background:new 0 0 936 936;" xml:space="preserve">
    <g [ngStyle]="{'fill': color, 'stroke': color}">
      <path
        d="M655.6,108.107l-510.1,300c-1.7,1-3.2,1.5-4.7,3.5H298l398.2-234.3c19-11.2,25.399-35.8,14.2-54.9   C699.2,103.307,674.7,96.907,655.6,108.107z" />
      <path
        d="M916,650.507h-13v-201.6c0-3.7-0.8-7.4-2.8-10.601l-69.101-110.6c-3.699-5.8-9.899-9.2-16.8-9.2H531.5   c-10.8,0-19.5,8.7-19.5,19.5v103.5H250.7H108.9H53.5c-11.3,0-20.5,9.2-20.5,20.5v27.5h25v86H33v75H20c-11,0-20,9-20,20v47   c0,11,9,20,20,20h13h19.7h53.7c0.1,0,1.4,8,1.5,8.7c1.6,8,4.2,15.7,7.6,23.1c3,6.5,6.7,12.8,10.9,18.601   c4.2,5.8,9,11.199,14.3,16.1c5.3,4.9,11,9.3,17.2,13.1c6.2,3.801,12.8,7,19.6,9.601c7,2.6,14.2,4.399,21.5,5.5   c5.3,0.8,10.7,1.2,16.1,1.2c29.5,0,58.2-12.4,78.6-33.7c16.8-17.4,26.399-39.5,30.1-63.2h312.8c-0.699,0.3,2.5,14.5,2.9,16   c12.6,46,55.1,80.9,105.6,80.9c29.5,0,58.101-12.4,78.601-33.601c16.5-17.1,26.6-38.899,30-62.3H916c11,0,20-9,20-20v-47   C936,659.507,927,650.507,916,650.507z M119,575.507v-86h4.6h44.7H185v86H119z M312,575.507h-66v-86h66V575.507z M440,575.507h-67   v-86h67V575.507z M567,575.507h-66v-86h66V575.507z M830.8,524.507H676.5c-8.3,0-15.5-6.7-15.5-15v-124.3c0-8.3,7.2-14.7,15.5-14.7   h114.4c5.1,0,9.899,2.4,12.6,6.8l39.8,62.3c1.5,2.4,2.3,5.101,2.4,8l0.1,62C845.8,517.807,839.1,524.507,830.8,524.507z    M260.1,723.507c0,8.3-2.2,16-6.1,22.7c-7.8,13.3-22.3,22.3-38.9,22.3c-24.9,0-45-20.1-45-45s20.1-45,45-45   S260.1,698.606,260.1,723.507z M790,723.507c0,8.3-2.2,16-6.1,22.7c-7.801,13.3-22.301,22.3-38.9,22.3c-24.9,0-45-20.1-45-45   s20.1-45,45-45S790,698.606,790,723.507z" />
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg> -->

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'voiture'" viewBox="0 0 512 512" width="512" height="512">
    <g id="_02-car" data-name="02-car">
      <g id="glyph" [ngStyle]="{'fill': color, 'stroke': color}">
        <path d="M112,340a60,60,0,1,0,60,60A60.068,60.068,0,0,0,112,340Zm0,92a32,32,0,1,1,32-32A32,32,0,0,1,112,432Z" />
        <path d="M416,340a60,60,0,1,0,60,60A60.068,60.068,0,0,0,416,340Zm0,92a32,32,0,1,1,32-32A32,32,0,0,1,416,432Z" />
        <path style="fill-opacity: 0.9;"
          d="M500.584,300.613C460.874,284.231,400,256,400,256l-48.483-78.7a35.857,35.857,0,0,0-27.94-13.3H83.777a43.762,43.762,0,0,0-39.355,24.322L8.645,259.878A43.992,43.992,0,0,0,4,279.554V376a36,36,0,0,0,36,36h1.019a72,72,0,1,1,141.962,0H345.019a72.005,72.005,0,1,1,142.461-3.492A36,36,0,0,0,508,376V311.7A11.99,11.99,0,0,0,500.584,300.613ZM60.4,247.245A15.988,15.988,0,0,1,46.139,256H30.584s25.4-50.338,34.949-68.565A12,12,0,0,1,76.164,181H85.99a5,5,0,0,1,4.472,7.241l-.04.081S69.684,228.945,60.4,247.245ZM112,300H96a12,12,0,0,1,0-24h16a12,12,0,0,1,0,24Zm108-56a12,12,0,0,1-11.994,12H100.6a12,12,0,0,1-10.67-17.484c8.419-16.366,20.612-39.93,26.594-51.154A12,12,0,0,1,127.111,181H208a12,12,0,0,1,12,12Zm68,56H273a12,12,0,0,1,0-24h15a12,12,0,0,1,0,24Zm-20-44a12,12,0,0,1-12-12V193a12,12,0,0,1,12-12h65.8L380,256Z" />
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'ecodd'" id="Capa_1" enable-background="new 0 0 512 512"
    height="512" viewBox="0 0 512 512" width="512">
    <g>
      <path
        d="m408.626 279.287c-30.12-69.785-114.376-190.519-74.377-271.86 2.031-4.131-1.902-8.655-6.242-7.121-34.764 12.29-127.515 56.016-98.742 165.872 0 0-26.651-31.57-50.353-41.509-3.511-1.472-7.317 1.323-7.03 5.12 5.031 66.419-42.202 101.992-69.523 158.087-24.492 50.286-14.005 99.368 11.14 143.133 18.671 32.497 46.679 57.283 79.127 72.109-2.027-1.914-3.988-3.922-5.87-6.033-18.393-20.632-27.098-48.51-23.882-76.484 3.212-27.939 23.062-53.984 42.257-79.172 23.049-30.243 44.82-58.81 34.017-83.711-2.554-5.887-1.136-12.744 3.543-17.135 4.678-4.391 11.611-5.37 17.323-2.447.99.507 24.463 12.741 42.099 40.831 11.797 18.791 22.723 47.651 18.732 87.561.298-.058.6-.107.904-.147 6.545-.862 12.891 2.585 15.723 8.544 17.771 37.397 16.279 82.094-3.799 113.873-5.855 9.266-13.039 17.034-21.315 23.202 98.392-30.36 134.403-144.358 96.268-232.713z"
        style="fill-opacity: 0.9;" [ngStyle]="{'fill': color, 'stroke': color}" />
      <path
        d="m270.773 287.042c-5.672 25.851-24.321 50.32-41.466 72.817-16.704 21.919-33.978 44.584-36.234 64.215-2.227 19.373 3.74 38.611 16.372 52.78 12.484 14.003 29.893 21.715 49.02 21.715 27.339 0 42.015-14.145 49.512-26.012 9.858-15.602 13.36-36.424 10.371-56.913-7.467 5.025-15.331 7.419-20.74 8.046-5.185.601-10.314-1.5-13.587-5.566-3.273-4.065-4.232-9.526-2.539-14.463 20.184-58.877 5.471-95.829-10.709-116.619z"
        [ngStyle]="{'fill': color, 'stroke': color}" />
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'ecostock'" viewBox="0 0 126.42 106.57">
    <defs>
      <style xmlns="http://www.w3.org/2000/svg">
        .Stockcls-1 {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 5px;
        }

        .Stockfade {
          opacity: 0.9
        }
      </style>
    </defs>
    <title>-Fichier 17EcoRec</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_1-2" data-name="Calque 1">
        <path class="Stockcls-1 Stockfade" d="M66.87,2.5V29a2,2,0,0,0,1.95,2h21a2,2,0,0,0,2-2V2.5Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="75.96" y1="8.81" x2="82.65" y2="8.81"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1 Stockfade" d="M34.69,2.5V29a2,2,0,0,0,2,2h21a2,2,0,0,0,1.95-2V2.5Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="43.77" y1="8.81" x2="50.47" y2="8.81"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1" d="M66.87,39V65.58a2,2,0,0,0,1.95,2h21a2,2,0,0,0,2-2V39Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1" x1="75.96" y1="45.35" x2="82.65" y2="45.35"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1" d="M34.69,39V65.58a2,2,0,0,0,2,2h21a2,2,0,0,0,1.95-2V39Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1" x1="43.77" y1="45.35" x2="50.47" y2="45.35"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1" d="M2.5,39V65.58a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V39Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1" x1="11.58" y1="45.35" x2="18.28" y2="45.35"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1 Stockfade" d="M99.06,75.59v26.53a2,2,0,0,0,2,1.95h21a2,2,0,0,0,2-1.95V75.59Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="108.14" y1="81.9" x2="114.84" y2="81.9"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1 Stockfade" d="M66.87,75.59v26.53a2,2,0,0,0,1.95,1.95h21a2,2,0,0,0,2-1.95V75.59Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="75.96" y1="81.9" x2="82.65" y2="81.9"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1 Stockfade" d="M34.69,75.59v26.53a2,2,0,0,0,2,1.95h21a2,2,0,0,0,1.95-1.95V75.59Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="43.77" y1="81.9" x2="50.47" y2="81.9"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <path class="Stockcls-1 Stockfade" d="M2.5,75.59v26.53a2,2,0,0,0,2,1.95h21a2,2,0,0,0,2-1.95V75.59Z"
          [ngStyle]="{'fill': color, 'stroke': color}" />
        <line class="Stockcls-1 Stockfade" x1="11.58" y1="81.9" x2="18.28" y2="81.9"
          [ngStyle]="{'fill': color, 'stroke': color}" />
      </g>
    </g>
  </svg>

  <svg version="1.1" *ngSwitchCase="'tournee'" id="Uploaded to svgrepo.com" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 32 32" xml:space="preserve">
    <style type="text/css">
      .linesandangles_een {
        fill: #111918;
      }
    </style>
    <path class="linesandangles_een" [ngStyle]="{'fill': color, 'stroke': color}" d="M16,4v2C10.486,6,6,10.486,6,16s4.486,10,10,10s10-4.486,10-10c0-3.594-1.937-6.866-5-8.64V11
 h-2V4h7v2h-3.375C25.941,8.199,28,11.933,28,16c0,6.617-5.383,12-12,12S4,22.617,4,16S9.383,4,16,4z" />
  </svg>


  <!-- <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'map_tournee'" width="800px" height="800px"
    viewBox="0 0 24 24">
    <defs>
      <style xmlns="http://www.w3.org/2000/svg">
        .StockTr-1 {
          fill: none;
          stroke-width: 2px;
        }
      </style>
    </defs>
    <path class="StockTr-1" [ngStyle]="{'fill': color, 'stroke': color}"
      d="M12,14 C9.790861,14 8,12.209139 8,10 C8,7.790861 9.790861,6 12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 Z M12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 C10.3431458,7 9,8.34314575 9,10 C9,11.6568542 10.3431458,13 12,13 Z M12.3391401,20.8674017 C12.1476092,21.0441994 11.8523908,21.0441994 11.6608599,20.8674017 C7.23483091,16.7818365 5,13.171725 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.171725 16.7651691,16.7818365 12.3391401,20.8674017 Z M18,10 C18,6.6862915 15.3137085,4 12,4 C8.6862915,4 6,6.6862915 6,10 C6,12.7518356 7.98660341,16.0353377 12,19.8163638 C16.0133966,16.0353377 18,12.7518356 18,10 Z" />
  </svg> -->


  <svg id="Layer_1" style="enable-background:new 0 0 91 91;" *ngSwitchCase="'map_chauffeur'" version="1.1"
    viewBox="0 0 91 91" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g>
      <path [ngStyle]="{'fill': color, 'stroke': color}"
        d="M74.5,54.6H43.6v-5.7h22.9c0.9,0,1.7-0.8,1.7-1.7V36.4c0-0.9-0.8-1.7-1.7-1.7h-7.6v-5.1c1.9-2.3,4.8-6,4.8-8.4   c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5c0,2.4,2.9,6.2,4.8,8.4v6.8c0,0.9,0.8,1.7,1.7,1.7h7.6v7.5H41.9   c-0.9,0-1.7,0.8-1.7,1.7v9.1c0,0.9,0.8,1.7,1.7,1.7h30.9v8H26.4v-4.3c2.8-3.2,8.2-9.8,8.2-13.8c0-5.4-4.4-9.9-9.9-9.9   c-5.4,0-9.9,4.4-9.9,9.9c0,4,5.4,10.6,8.2,13.8v6c0,0.9,0.8,1.7,1.7,1.7h49.7c0.9,0,1.7-0.8,1.7-1.7V56.3   C76.1,55.3,75.4,54.6,74.5,54.6z M57.2,19.1c1.2,0,2.1,1,2.1,2.1c0,1.2-1,2.1-2.1,2.1c-1.2,0-2.2-1-2.2-2.1   C55,20.1,56,19.1,57.2,19.1z M21.4,47.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4   C22.9,50.9,21.4,49.4,21.4,47.6z" />
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'planning-moyens'" width="800px" height="800px"
    viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd" transform="translate(-7 -18)">
      <path d="M0 0h48v48H0z" />
      <rect [ngStyle]="{'fill': color}" width="34" height="4" x="7" y="25" fill="#FFF" rx="1" />
      <rect [ngStyle]="{'fill': color}" width="14" height="4" x="7" y="32" fill="#FFF" fill-opacity=".2" rx="1" />
    </g>
  </svg>


  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'validation'" xmlns:xlink="http://www.w3.org/1999/xlink"
    width="512px" height="512px" viewBox="0 0 24 24">
    <defs>
      <path id="a" d="M0 0h8.333v20H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path d="M-9-17h48v48H-9z" />
      <path [ngStyle]="{'fill': silver, 'stroke': color}" fill="#FFF" fill-opacity=".2" fill-rule="nonzero"
        d="M20.9 19.327a.902.902 0 0 1 1.803 0V20H30v-5.022c-2.432-.36-4.324-2.422-4.324-4.978 0-2.556 1.892-4.619 4.324-4.978V0h-7.297v.673a.902.902 0 0 1-1.802 0V0H0v5.067A5.019 5.019 0 0 1 4.144 10c0 2.466-1.802 4.484-4.144 4.933V20h20.856v-.673h.045zm0-14.44a.902.902 0 0 1 1.803 0v2.96a.902.902 0 0 1-1.802 0v-2.96zm0 7.22a.902.902 0 0 1 1.803 0v2.96a.902.902 0 0 1-1.802 0v-2.96z" />
      <g transform="translate(21.667)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a" />
        </mask>
        <g fill="#FFF" fill-rule="nonzero" mask="url(#b)">
          <path [ngStyle]="{'fill': color, 'stroke': silver}"
            d="M-.766 19.327a.902.902 0 0 1 1.802 0V20h7.297v-5.022C5.901 14.618 4.01 12.556 4.01 10c0-2.556 1.892-4.619 4.324-4.978V0H1.036v.673a.902.902 0 0 1-1.802 0V0h-20.9v5.067A5.019 5.019 0 0 1-17.524 10c0 2.466-1.801 4.484-4.144 4.933V20H-.81v-.673h.045zm0-14.44a.902.902 0 0 1 1.802 0v2.96a.902.902 0 0 1-1.802 0v-2.96zm0 7.22a.902.902 0 0 1 1.802 0v2.96a.902.902 0 0 1-1.802 0v-2.96z" />
        </g>
      </g>
    </g>
  </svg>

  <svg xmlns="http://www.w3.org/2000/svg" *ngSwitchCase="'parcentretien'" viewBox="0 0 106.52 106.54">
    <defs>
      <style>
        .cls-1 {
          fill: #fff;
          stroke: rgba(255, 255, 255, 0.2);
          stroke-miterlimit: 10;
          stroke-width: 2.5px;
        }
      </style>
    </defs>
    <title>Parc entretient</title>
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_1-2" data-name="Calque 1">
        <path class="cls-1" [ngStyle]="{'fill': color, 'stroke': color}"
          d="M44.22,46.14,26.84,63.52A20.9,20.9,0,0,0,7.42,69.23c-9.21,9.21-7.18,22.68,0,29.88a21.16,21.16,0,0,0,29.89,0A20.9,20.9,0,0,0,43,79.69L60.68,62h0L78.46,44.11a.82.82,0,0,1,.58-.17,21.51,21.51,0,0,0,26.18-22.8,2.91,2.91,0,0,0-1.84-2.39,3.07,3.07,0,0,0-3.17.61L92.54,27,81.07,25.59,79.49,14.13,87.3,6.32a2.9,2.9,0,0,0,.72-3,3,3,0,0,0-2.6-2A22.23,22.23,0,0,0,68.31,7.58a21.26,21.26,0,0,0-5.87,19.7.71.71,0,0,1-.16.67ZM64.6,30.53a4,4,0,0,0,1.26-3.92,17.8,17.8,0,0,1,4.89-16.56,18.87,18.87,0,0,1,13.1-5.33H84l-7,6.94a3.28,3.28,0,0,0-.88,2.48l1.52,12.08A3,3,0,0,0,80.21,29L92.6,30.52a3.16,3.16,0,0,0,2.25-.9l7-6.95a18.29,18.29,0,0,1-5.29,13.06,18.39,18.39,0,0,1-16.82,4.78A4.39,4.39,0,0,0,76,41.64L57.91,59.85h0l-18,18.07a1.77,1.77,0,0,0-.46,1.68,17.47,17.47,0,0,1-4.56,17.05,17.67,17.67,0,0,1-25,0c-6-6-7.7-17.27,0-25a17.5,17.5,0,0,1,17-4.57,1.74,1.74,0,0,0,1.68-.45l18.06-18h0l0,0,.27-.27h0Z" />
        <path class="cls-1"
          d="M28.48,76.84l-7.71-2.07a1.72,1.72,0,0,0-1.68.45l-5.65,5.65A1.72,1.72,0,0,0,13,82.54l2.06,7.72a1.74,1.74,0,0,0,1.23,1.23L24,93.56a1.73,1.73,0,0,0,1.68-.45l5.65-5.65a1.69,1.69,0,0,0,.45-1.67l-2.06-7.72A1.75,1.75,0,0,0,28.48,76.84Zm-4.55,13.1-5.77-1.55-1.55-5.78,4.23-4.22,5.76,1.55,1.55,5.77Z" />
        <path class="cls-1" d="M40.32,63.74a1.74,1.74,0,1,0,2.46,2.46L64.26,44.73a1.74,1.74,0,1,0-2.47-2.46Z" />
      </g>
    </g>
  </svg>

  <svg width="800px" height="800px" viewBox="0 0 24 24" id="Layer_1" *ngSwitchCase="'rdv'" data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <style>
        .cls-1 {
          fill: none;
        }

        
      </style>
      <clipPath id="clip-path">
        <rect class="cls-1" width="24" height="24" />
      </clipPath>
    </defs>
    <title>rdv</title>
    <g class="cls-2" style="clip-path: url(#clip-path)">
      <path [ngStyle]="{ 'fill': color}"
        d="M11,13.56a3.78,3.78,0,1,1,3.78-3.78A3.79,3.79,0,0,1,11,13.56ZM11,8a1.78,1.78,0,1,0,1.78,1.78A1.78,1.78,0,0,0,11,8Z" />
      <path [ngStyle]="{ 'fill': color}"
        d="M16,18a1,1,0,0,1-1-1,3.44,3.44,0,0,0-3.44-3.44H10.44A3.44,3.44,0,0,0,7,17a1,1,0,0,1-2,0,5.45,5.45,0,0,1,5.44-5.44h1.12A5.45,5.45,0,0,1,17,17,1,1,0,0,1,16,18Z" />
      <path [ngStyle]="{ 'fill': color}"
        d="M16.6,21H5.4A3.41,3.41,0,0,1,2,17.6V6.4A3.41,3.41,0,0,1,5.4,3H16.6A3.41,3.41,0,0,1,20,6.4V17.6A3.41,3.41,0,0,1,16.6,21ZM5.4,5A1.4,1.4,0,0,0,4,6.4V17.6A1.4,1.4,0,0,0,5.4,19H16.6A1.4,1.4,0,0,0,18,17.6V6.4A1.4,1.4,0,0,0,16.6,5Z" />
      <path [ngStyle]="{ 'fill': color}" d="M21,10.78H19a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z" />
      <path [ngStyle]="{ 'fill': color}" d="M21,16H19a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z" />
    </g>
  </svg>

  <svg fill="#000000" height="800px" *ngSwitchCase="'relance'" width="800px" version="1.1" id="Capa_1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60.005 60.005"
    xml:space="preserve">
    <g>
      <path [ngStyle]="{ 'fill': color}" d="M26.199,46.525c-0.546-0.104-1.069,0.24-1.18,0.781c-1.116,5.502-5.445,9.199-10.771,9.199c-5.028,0-9.446-3.3-10.948-8H8
      v-2H0v8h2v-3.849c2.169,4.681,6.915,7.849,12.249,7.849c6.304,0,11.42-4.341,12.731-10.801
      C27.09,47.163,26.74,46.635,26.199,46.525z" />
      <path [ngStyle]="{ 'fill': color}"
        d="M26,38.814c-2.25-4.454-6.704-7.309-11.751-7.309c-6.109,0-11.541,3.997-13.209,9.721c-0.154,0.53,0.15,1.085,0.681,1.239
      c0.529,0.155,1.085-0.15,1.239-0.681c1.398-4.797,6.146-8.279,11.289-8.279c4.565,0,8.562,2.766,10.33,7H20v2h8v-8h-2V38.814z" />
      <path [ngStyle]="{ 'fill': color}" d="M59.427,42.41c-2.008-3.796-8.98-7.912-9.287-8.092c-1.278-0.727-2.599-0.957-3.723-0.646
      c-0.844,0.233-1.531,0.767-1.994,1.545c-1.02,1.22-2.285,2.646-2.592,2.867c-2.371,1.604-4.252,1.414-6.295-0.629L24.05,25.969
      c-2.045-2.045-2.233-3.928-0.631-6.292c0.224-0.31,1.649-1.575,2.869-2.595c0.778-0.464,1.312-1.151,1.546-1.996
      c0.311-1.123,0.081-2.444-0.653-3.731c-0.173-0.296-4.289-7.269-8.085-9.276C17.173,1.06,14.841,1.408,13.3,2.951l-2.536,2.536
      C4.73,11.52,4.532,18.89,10.19,26.801c0.321,0.449,0.945,0.552,1.396,0.231c0.449-0.321,0.553-0.946,0.231-1.396
      c-5.156-7.209-5.038-13.338,0.36-18.736l2.536-2.536c0.918-0.916,2.304-1.123,3.446-0.519c3.294,1.743,7.256,8.453,7.289,8.51
      c0.449,0.787,0.62,1.608,0.457,2.196c-0.1,0.36-0.323,0.634-0.684,0.836l-0.15,0.104c-0.853,0.712-2.883,2.434-3.308,3.062
      c-0.612,0.904-1.018,1.793-1.231,2.666c-0.711-1.418-1.286-3.061-1.475-4.881c-0.058-0.548-0.547-0.947-1.099-0.892
      c-0.549,0.058-0.948,0.549-0.892,1.099c0.722,6.953,6.13,11.479,6.359,11.668c0.026,0.021,0.056,0.029,0.083,0.047l10.61,10.61
      c0.044,0.044,0.089,0.083,0.134,0.126c0.036,0.052,0.059,0.111,0.106,0.157c0.189,0.187,4.704,4.567,11.599,5.283
      c0.035,0.003,0.07,0.005,0.104,0.005c0.506,0,0.94-0.383,0.994-0.896c0.057-0.55-0.343-1.041-0.892-1.099
      c-2.115-0.219-3.989-0.84-5.55-1.559c0.766-0.23,1.545-0.612,2.334-1.146c0.628-0.425,2.35-2.455,3.062-3.308l0.104-0.151
      c0.202-0.359,0.475-0.583,0.835-0.683c0.587-0.164,1.409,0.008,2.187,0.45c1.879,1.102,7.072,4.559,8.521,7.296
      c0.605,1.145,0.397,2.529-0.519,3.445l-2.537,2.537c-5.394,5.392-11.79,5.446-19.016,0.159c-0.447-0.329-1.073-0.23-1.397,0.216
      c-0.326,0.446-0.229,1.071,0.216,1.397c3.935,2.88,7.733,4.317,11.306,4.317c3.718,0,7.189-1.56,10.306-4.676l2.537-2.537
      C60.096,46.664,60.446,44.335,59.427,42.41z" />
    </g>
  </svg>

  <svg width="800px" height="800px" *ngSwitchCase="'pro_forma'" viewBox="0 0 32 32" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path [ngStyle]="{ 'stroke': color}"
      d="M19 1C19 1 20 1 21 2L28 9C29 10 29 11 29 11V30C29 31 28 31 28 31H4C3 31 3 30 3 30V2C3 1 4 1 4 1H19ZM19 1V10C19 10 19 11 20 11H25M9 17H15M9 21H23M9 25H23"
      stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <svg fill="#000000" width="800px" height="800px" *ngSwitchCase="'rh_paie'" viewBox="-5.5 0 32 32" version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <title>PAIE</title>
    <path [ngStyle]="{ 'fill': color}"
      d="M18.28 8.12h-15.36c-1.6 0-2.92 1.32-2.92 2.92v9.92c0 1.6 1.32 2.92 2.92 2.92h15.36c1.6 0 2.92-1.32 2.92-2.92v-9.92c0-1.6-1.32-2.92-2.92-2.92zM2.92 9.8h15.36c0.68 0 1.24 0.56 1.24 1.24v1.6h-17.8v-1.6c0-0.68 0.52-1.24 1.2-1.24zM18.28 22.2h-15.36c-0.68 0-1.24-0.56-1.24-1.24v-6.64h17.8v6.64c0.040 0.68-0.52 1.24-1.2 1.24z">
    </path>
  </svg>

  <svg width="800px" height="800px" *ngSwitchCase="'heure'" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path [ngStyle]="{ 'stroke': color}"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path [ngStyle]="{ 'stroke': color}" d="M12 6V12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round" />
    <path [ngStyle]="{ 'stroke': color}" d="M16.24 16.24L12 12" stroke="#000000" stroke-width="1.5"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <svg width="800px" height="800px" *ngSwitchCase="'dechet_sortie'" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path [ngStyle]="{ 'stroke': color}"
      d="M12 7V17M12 7L16 11M12 7L8 11M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <svg width="800px" height="800px" *ngSwitchCase="'dechet_entree'" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path [ngStyle]="{ 'stroke': color}"
      d="M12 17L12 7M12 17L8 13M12 17L16 13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <svg width="800px" height="800px" *ngSwitchCase="'stock'" viewBox="0 -1 32 32" version="1.1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
    <title>Stock</title>
    <defs>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
      <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-152.000000, -204.000000)" fill="#000000">
        <path [ngStyle]="{ 'stroke': color}"
          d="M152.915,221.057 L166.492,227.159 C167.691,227.725 168.209,227.725 169.509,227.159 L183.085,221.057 C183.755,220.744 184,219.275 184,218.484 C183.127,218.921 181.891,219.544 181.867,219.55 L168,225.942 L154.133,219.55 C154.181,219.579 152.906,219.002 152,218.484 C152,219.258 152.194,220.674 152.915,221.057 L152.915,221.057 Z M168,232.335 L154.133,225.942 C154.181,225.972 152.906,225.395 152,224.877 C152,225.65 152.194,227.066 152.915,227.449 L166.492,233.552 C167.691,234.118 168.209,234.118 169.509,233.552 L183.085,227.449 C183.755,227.137 184,225.668 184,224.877 C183.127,225.313 181.891,225.937 181.867,225.942 L168,232.335 L168,232.335 Z M168,205.698 L181.867,213.156 L168,219 L154.133,213.156 L168,205.698 L168,205.698 Z M152.915,214.663 L166.492,220.767 C167.691,221.332 168.209,221.332 169.509,220.767 L183.085,214.663 C184.085,214.197 184.118,212.216 183.085,211.649 L169.509,204.481 C168.442,203.849 167.691,203.882 166.492,204.481 L152.915,211.649 C151.882,212.315 151.849,214.098 152.915,214.663 L152.915,214.663 Z M168,205.698 C168.1,205.815 168.074,205.723 168,205.698 L168,205.698 Z"
          id="layers" sketch:type="MSShapeGroup">

        </path>
      </g>
    </g>
  </svg>


  <svg fill="#000000" width="800px" height="800px" *ngSwitchCase="'tri_entree'" viewBox="0 0 24 24" id="recycle-3"
    xmlns="http://www.w3.org/2000/svg" class="icon line">
    <path [ngStyle]="{ 'stroke': color}" id="primary" d="M11,5H4.09a1.08,1.08,0,0,0-.94,1.62l2.21,3.73"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-2" data-name="primary" points="9 3 11 5 9.3 7"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
    <path [ngStyle]="{ 'stroke': color}" id="primary-3" data-name="primary"
      d="M17.4,12.61l3.45-6A1.07,1.07,0,0,0,19.93,5L16,5.05"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-4" data-name="primary"
      points="20.13 11.88 17.4 12.61 16.52 10.13"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
    <path [ngStyle]="{ 'stroke': color}" id="primary-5" data-name="primary"
      d="M7.64,14.47l3.46,6a1.08,1.08,0,0,0,1.87,0l2.12-3.79"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-6" data-name="primary"
      points="6.91 17.2 7.64 14.47 10.22 14.94"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
  </svg>

  <svg fill="#000000" width="800px" height="800px" *ngSwitchCase="'tri_sortie'" viewBox="0 0 24 24" id="recycle-3"
    xmlns="http://www.w3.org/2000/svg" class="icon line">
    <path [ngStyle]="{ 'stroke': color}" id="primary" d="M13,5H19.91a1.08,1.08,0,0,1,.94,1.62l-2.21,3.73"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-2" data-name="primary" points="15 3 13 5 14.7 7"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
    <path [ngStyle]="{ 'stroke': color}" id="primary-3" data-name="primary"
      d="M6.6,12.61l-3.45-6A1.07,1.07,0,0,1,4.07,5L8,5.05"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-4" data-name="primary" points="3.87 11.88 6.6 12.61 7.48 10.13"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
    <path [ngStyle]="{ 'stroke': color}" id="primary-5" data-name="primary"
      d="M16.36,14.47l-3.46,6a1.08,1.08,0,0,1-1.87,0l-2.12-3.79"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </path>
    <polyline [ngStyle]="{ 'stroke': color}" id="primary-6" data-name="primary"
      points="17.09 17.2 16.36 14.47 13.78 14.94"
      style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;">
    </polyline>
  </svg>



  <svg fill="#000000" height="800px" width="800px" *ngSwitchCase="'map_tournee'" version="1.1" id="Capa_1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 368.553 368.553"
    xml:space="preserve">
    <g>
      <g>
        <path [ngStyle]="{'fill': color, 'stroke': color}" d="M184.277,0c-71.683,0-130,58.317-130,130c0,87.26,119.188,229.855,124.263,235.883c1.417,1.685,3.504,2.66,5.705,2.67
			c0.011,0,0.021,0,0.032,0c2.189,0,4.271-0.957,5.696-2.621c5.075-5.926,124.304-146.165,124.304-235.932
			C314.276,58.317,255.96,0,184.277,0z M184.322,349.251C160.385,319.48,69.277,201.453,69.277,130c0-63.411,51.589-115,115-115
			s115,51.589,115,115C299.276,203.49,208.327,319.829,184.322,349.251z" />
        <path [ngStyle]="{'fill': color, 'stroke': color}" d="M184.277,72.293c-30.476,0-55.269,24.793-55.269,55.269s24.793,55.269,55.269,55.269s55.269-24.793,55.269-55.269
			S214.753,72.293,184.277,72.293z M184.277,167.83c-22.204,0-40.269-18.064-40.269-40.269s18.064-40.269,40.269-40.269
			s40.269,18.064,40.269,40.269S206.48,167.83,184.277,167.83z" />
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </g>
  </svg>


  <svg version="1.1" *ngSwitchCase="'planning-maintenance'" id="Uploaded to svgrepo.com"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px"
    viewBox="0 0 32 32" xml:space="preserve">
    <style type="text/css">
      .bentblocks_een {
        fill: #0B1719;
      }

      .st0 {
        fill: #0B1719;
      }
    </style>
    <path [ngStyle]="{'fill': color, 'stroke': color}" class="bentblocks_een" d="M4,10h6V4H4V10z M6,6h2v2H6V6z M28,6v2H14V6H28z M4,19h6v-6H4V19z M6,15h2v2H6V15z M14,15h14v2H14
	V15z M4,28h6v-6H4V28z M6,24h2v2H6V24z M14,24h14v2H14V24z" />
  </svg>

</span>